<template>
  <!-- eslint-disable max-len -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" @click="$emit('click')">
    <path :fill="color" d="M15 7H1v2h14z"/>
  </svg>
</template>
<script>
export default {
  name: 'Minus',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
